const CONFIGURABLE_LOBS = {
  LOSS_INDICATOR_FIELDS: {
    is_injured: 'bodily_injury_loss',
    is_related_property_loss: 'related_property_loss',
    is_property_damaged: 'property_damage',
    is_pecuniary_loss: 'pecuniary_loss',
  },
  LOSS_GROUP_FIELDS: {
    bodily_injury_loss: [
      'was_ambulance_needed',
      'was_hospitalized',
      'hospital_contact_id',
      'admission_datetime',
      'discharge_datetime',
      'legal_venue_state',
      'legal_venue_reason',
      'injuries',
      'injuries_description',
      'note',
    ],
    property_damage: ['damages_description', 'location', 'note'],
  },
  SUPPLEMENTARY_INFORMATION_FIELDS: {
    base: [
      'did_anyone_take_photos_or_video',
      'photographer_contact_id',
      'is_other_policy_covering',
      'is_notification_only',
      'was_cctv_footage',
      'can_take_photos_of_damage',
      'other_policy_description',
    ],
    lob_specific: {
      auto_claim: {
        config_group: 'auto_incident_additional',
        fields: [
          'was_replacement_car_rented',
          'replacement_car_rental_date',
          'are_convictions_or_claims_in_the_last_5_years',
          'convictions_or_claim_description',
          'is_policyholder_occupation_right',
          'policyholder_current_occupation',
          'does_policyholder_second_occupation_exist',
          'policyholder_second_occupation',
        ],
      },
    },
  },
} as const;

export default CONFIGURABLE_LOBS;
